import { render, staticRenderFns } from "./MaitriseDesLangues.vue?vue&type=template&id=70b87f1d&"
import script from "./MaitriseDesLangues.vue?vue&type=script&lang=js&"
export * from "./MaitriseDesLangues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports